import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, setDefaultCurrency } from "@/lib/api";

const AuthContext = createContext(null);
const DEFAULT_BRAND = { agency_name: "Sugar Cubes Agency", logo_light: "/brand/logo-white.webp", logo_dark: "/brand/logo-black.webp", default_currency: "INR", email_configured: false };

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [brand, setBrand] = useState(DEFAULT_BRAND);

  const loadBrand = useCallback(async () => {
    try {
      const { data } = await api.get("/settings/branding");
      setBrand(data);
      setDefaultCurrency(data.default_currency);
      document.title = data.agency_name;
    } catch { /* keep defaults */ }
  }, []);
  useEffect(() => { loadBrand(); }, [loadBrand]);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: skip /me when returning from OAuth; AuthCallback exchanges the session first.
    if (window.location.hash?.includes("session_id=")) return;
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };
  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    setUser(data);
    return data;
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, setUser, login, register, logout, checkAuth, brand, loadBrand }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);

export const homeFor = (user) => (user?.role === "admin" ? "/dashboard" : user?.role === "employee" ? "/my-work" : "/portal");
